import { render, staticRenderFns } from "./FooterWave.vue?vue&type=template&id=a57f9e68&scoped=true&"
import script from "./FooterWave.vue?vue&type=script&lang=js&"
export * from "./FooterWave.vue?vue&type=script&lang=js&"
import style0 from "./FooterWave.vue?vue&type=style&index=0&id=a57f9e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57f9e68",
  null
  
)

export default component.exports